export const navigation = {
  main: 97,
  flyout: 99,
  side: 96,
  sideHover: 95,
  underlay: {
    over: 98,
    under: -1
  }
};
export const searchSuggestions = 100;
export const modal = 101;
export const fullScreenSpinner = 1301;
export const typeaheadSuggestion = 1300;
